import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetTransactionReportsCountByDayQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import { useFilters } from '../../context/filters.context';

export const TransactionsByDayCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetTransactionReportsCountByDayQuery({
    ...transformedFilters,
  });

  return (
    <ByDateCard data={data} variant={ByDateCardVariantEnum.Transactions} />
  );
};
